import { Select, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Notification } from "src/utils/Notification";

import { useIsOnline, usePostApi } from "../../../../hooks";
import { Flex } from "../../../../styled";

const statuses = ["CLOSED", "MONITORING", "ACTIVE"];

const normalizeStatus = (status: string | null | undefined): string | null => {
  if (!status) return null;
  const upper = status.toUpperCase();
  return statuses.includes(upper) ? upper : null;
};

interface Props {
  defaultValue: string | null | undefined;
  style?: any;
}

const EventMedLogSelect = ({ defaultValue, style }: Props) => {
  const isOnline = useIsOnline();
  const { lbeidOrPartId } = useParams();
  const { post } = usePostApi();
  const [value, setValue] = useState<string | null>(
    normalizeStatus(defaultValue),
  );
  useEffect(() => {
    setValue(normalizeStatus(defaultValue));
  }, [defaultValue]);
  const handleChange = (v: string | null) => {
    if (lbeidOrPartId && v)
      void post({
        request: "update-event-status",
        body: {
          params: {
            meid: lbeidOrPartId,
            status: v?.toLowerCase(),
          },
        },
        onSuccess: r => {
          Notification("Success", "Entry status updated successfully", "green");
        },
      });

    setValue(v);
  };

  return (
    <Flex gap={15} align="center" style={{ ...style }}>
      <Text>Event Status</Text>
      <Select
        data={statuses}
        value={value}
        onChange={handleChange}
        disabled={!isOnline}
      />
    </Flex>
  );
};
export default EventMedLogSelect;
